import {AssetXMPPacketStatus} from '@netx/core-asset-next/schema';
import {type IAsset} from '../schema';
import {
	assetPermissionChecker,
	PermissionMatrixName,
	PermissionName,
} from '@netx/core-permissions-next/utils';

export const assetHasMetadata = (asset?: IAsset): asset is IAsset => {
	if (!asset) return false;
	if (
		![
			AssetXMPPacketStatus.STORED,
			AssetXMPPacketStatus.NOT_STORED_TOO_LARGE,
		].includes(asset.xmpPacketStatus)
	)
		return false;
	return true;
};
